import ReactInputMask from "react-input-mask"
import React, { useEffect } from 'react'
import { useState } from 'react'
import {TIME_FORMAT} from "../../utils/constants"
import PropTypes from "prop-types"
import {Grid, TextField} from "@mui/material"

const TimerInputRange = ({ onChange }) => {
    const [first, setFirst] = useState("")
    const [second, setSecond] = useState("")

    useEffect(() => {
        if (first.length === 5 && second.length === 5) {
            onChange(first, second)
        }
    }, [first, second])

    return (
        <Grid container direction={"row"} alignContent={"flex-end"} justifyContent={"flex-end"} spacing={2}>
            <Grid item xs={6} sm={6} md={6}>
                <ReactInputMask
                    mask={TIME_FORMAT}
                    value={first}
                    onChange={(e) => setFirst(e.target.value)}
                    maskChar=""
                >
                    {(inputProps) => (
                        <TextField
                            {...inputProps}
                            fullWidth
                            label="Hora Inicial"
                        />
                    )}
                </ReactInputMask>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
                <ReactInputMask
                    mask={TIME_FORMAT}
                    value={second}
                    onChange={(e) => setSecond(e.target.value)}
                    maskChar=""
                >
                    {(inputProps) => (
                        <TextField
                            {...inputProps}
                            fullWidth
                            label="Hora Final"
                        />
                    )}
                </ReactInputMask>
            </Grid>
        </Grid>
    )
}

TimerInputRange.propTypes = {
    props: PropTypes.object,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default TimerInputRange